function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#f8d1aa;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M89.86,0C78.07,0,71,8.84,71,20.22c0,11.05,7,19.89,18.83,19.89s18.82-8.84,18.82-19.89C108.68,8.84,101.66,0,89.86,0Zm0,33c-7.57,0-10.41-6.43-10.41-12.81,0-6.71,2.84-13.14,10.41-13.14s10.41,6.43,10.41,13.14C100.27,26.6,97.42,33,89.86,33Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M269.14.91h-8.63L246,39.2h8.52l3-8.52h14.33l2.89,8.52h8.74ZM259.7,24.4l5-14h.1l4.83,14.05Z"
}), React.createElement("polygon", {
  className: "cls-1",
  points: "230.56 39.2 238.98 39.2 238.98 7.99 250.46 7.99 250.46 0.91 219.09 0.91 219.09 7.99 230.56 7.99 230.56 39.2"
}), React.createElement("polygon", {
  className: "cls-1",
  points: "182.72 39.2 190.6 39.2 190.6 13.57 190.71 13.57 206.64 39.2 215.06 39.2 215.06 0.91 207.17 0.91 207.17 26.6 207.07 26.6 191.08 0.91 182.72 0.91 182.72 39.2"
}), React.createElement("polygon", {
  className: "cls-1",
  points: "148.07 39.2 177.14 39.2 177.14 32.12 156.49 32.12 156.49 22.74 175.05 22.74 175.05 16.2 156.49 16.2 156.49 7.99 176.71 7.99 176.71 0.91 148.07 0.91 148.07 39.2"
}), React.createElement("path", {
  className: "cls-1",
  d: "M66.2,30.14c-.26-3.92-1.45-7.83-5.58-9v-.11c4.3-1.71,6.06-5.09,6.06-9.6C66.68,5.68,62.34.91,55.47.91H34.82V39.2h8.43v-15h8.42c4.24,0,5.79,1.77,6.38,5.8.43,3.05.38,6.74,1.34,9.16h8.42C66.26,37.12,66.36,32.56,66.2,30.14ZM52.48,18.23H43.25V7.46h9.23c3.8,0,5.79,1.6,5.79,5.3C58.27,16.62,56.28,18.23,52.48,18.23Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M17.27.91H0V39.2H8.42V25.48h8.85c9.61,0,13.25-6.06,13.25-12.29S26.88.91,17.27.91Zm-2.3,18H8.42V7.46H15c3.85,0,7.39.85,7.39,5.73S18.82,18.93,15,18.93Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M125.35,10.39c-1.21-1.77-2.17-3.15-2.73-3.88-2.15-3-3.52-5.65-8-5.65h-5.56l6.29,9.53Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M141.18,39.15h3.24s-3.64-4.83-6.74-9.54h-9.62l2.33,3.48c4,6.06,4,6.06,10.79,6.06Z"
}), React.createElement("polygon", {
  className: "cls-1",
  points: "109.02 39.15 118.51 39.15 144.36 0.86 140.57 0.86 135.13 0.86 132.13 5.26 109.02 39.15"
})));

var SvgLogoNew = function SvgLogoNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 283.46 40.11",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-new.7d9f7b64.svg";
export { ForwardRef as ReactComponent };